import type { StateCreator } from 'zustand';
import { persist } from '../persist';
import type { GameState } from '../types';

export interface TutorialSlice {
  tutDone: boolean;
  disclaimerDone: boolean;
  tutStep: number;

  confirmDisclaimer: () => void;
  setTutStep: (step: number) => void;
  endTutorial: () => void;
}

export const createTutorialSlice: StateCreator<GameState, [], [], TutorialSlice> = (set, get) => ({
  tutDone: false,
  disclaimerDone: false,
  tutStep: -1,

  confirmDisclaimer: () => {
    set({ disclaimerDone: true, showDisclaimerModal: false });
    persist(get());
    if (!get().tutDone) get().setTutStep(0);
    else set({ tickPaused: false });
  },

  setTutStep: (step) => {
    set({ tutStep: step, tickPaused: true });
  },

  endTutorial: () => {
    set({ tutDone: true, tutStep: -1, tickPaused: false });
    persist(get());
  },
});
